import * as React from 'react'
import { Typography, Paper, Box, Button, makeStyles, Grid, TextField, Divider,  Tabs, Tab,  withStyles, Theme, createStyles, debounce, CircularProgress, Select } from '@material-ui/core'

import { getClientProfiles, getCoaching, saveCoachingSessions, saveCoachingNotes } from '../../utils/api';
import { useParams } from 'react-router';
import { useFeedback } from '../../components/Feedback';
import ClientProfilesView from '../../components/ClientProfilesView';
import { DefaultClientProfiles } from '../../constants';
import { Rating } from '@material-ui/lab'
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => createStyles({
    titleBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    editor: {
        height: '500px'
    },
    unfinished: {
        color: theme.palette.warning.main
    },
    finished: {
        color: theme.palette.success.main
    },
}))

const saveNotesDebounce = debounce((id, content, clientId, success) => {
    success(0)
    return saveCoachingNotes(id, content, clientId).then(res => {
        success(1)
    })
}, 1000)

const ClientCoaching = () => {

    const { showToast, showLoading, hideLoading } = useFeedback()
    const classes = useStyles()
    const params: { id: string, clientId: string } = useParams()
    const [level, setLevel] = React.useState(1)
    const [numberOfTimes, setNumberOfTimes] = React.useState(0)
    const [notesSaveing, setNoteSaveing] = React.useState(false)
    const [tabIndex, setTabIndex] = React.useState(0)
    const [material, setMaterial] = React.useState('')
    const [profiles, setProfiles] = React.useState<ClientProfiles>(DefaultClientProfiles)
    const [checkDate, setCheckDate] = React.useState<Date | null>(moment().add(3, 'day').toDate())
    const [nextSessionDate, setNextSessionDate] = React.useState<Date | null>(moment().add(7, 'day').toDate())
    const [notes, setNotes] = React.useState<string>('')
    const [coachingId, setCoachingId] = React.useState<string | null>(null)
    const [lastWeeklyObjectives, setLastWeeklyObjectives] = React.useState<WeeklyObjectives[]>([])
    const [goals, setGoals] = React.useState<string[]>(['', '', ''])
    const [hinderAndMeasures, setHinderAndMeasures] = React.useState<string>('')
    const [reviews, setReviews] = React.useState('')
    const [nextWeeklyObjectives, setNextWeeklyObjectives] = React.useState<WeeklyObjectives[]>([
        { objectives: '', index: 1 },
        { objectives: '', index: 2 },
        { objectives: '', index: 3 },
    ])



    const loadData = () => {
        getClientProfiles(params.clientId).then(res => {
            setProfiles(res.data)
        })
        getCoaching(params.id).then(res => {
            const coaching = res.data.coaching;
            const lastCoachingSession = res.data.lastCoachingSession;
            setCoachingId(coaching.id)
            setNotes(res.data.notes)
            if (coaching.goals) {
                const resultGoals = coaching.goals.split(',')
                for (let i = 0; i < 3; i++) {
                    if (resultGoals[i]) {
                        goals[i] = resultGoals[i]
                    }
                }
                setGoals([...goals])
            }

            if (lastCoachingSession) {
                setLevel(lastCoachingSession.level + 1)
                setLastWeeklyObjectives(lastCoachingSession.weeklyObjectives)
            }
            setNumberOfTimes(coaching.number_of_times)

        })
    }

    React.useEffect(() => {
        loadData()
    }, [])


    const textareaProps = {
        style: { height: '100%' },
        inputProps: {
            style: { height: '100%', overflow: 'auto' }
        },
        InputProps: {
            style: { height: '100%' }
        }
    }

    const PlanTab = withStyles((theme: Theme) =>
        createStyles({
            root: {
                textAlign: 'left',
                '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText
                },

            },
            selected: {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            }
        })
    )(Tab)

    const onGoalsChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        goals[index] = event.target.value
        setGoals([...goals])
    }

    const onNextWeeklyObjectsChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        nextWeeklyObjectives[index].objectives = event.target.value;
        setNextWeeklyObjectives([...nextWeeklyObjectives])
    }


    const handleNotesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNotes(event.target.value)
        saveNotes(event.target.value)
    }



    const saveNotes = (content: string) => {
        saveNotesDebounce(coachingId, content, params.clientId, (type: number) => {
            setNoteSaveing(!type)
        })

    }

    const checkParams = () => {

        let hasGoal = false
        for (let goal of goals) {
            if (goal) {
                hasGoal = true;
            }
        }

        if (!hasGoal) {
            showToast('请填写教练目标')
            return false;
        }

        if (level !== 1) {
            for (let last of lastWeeklyObjectives) {
                if (!last.complete_level || !last.complate_quality) {
                    showToast('请评估评估上周计划执行情况')
                    return false;
                }
            }
        }

        if (level <= numberOfTimes) {
            let hasNextObj = false
            for (let next of nextWeeklyObjectives) {
                if (next.objectives) {
                    hasNextObj = true
                }
            }
            if (!hasNextObj) {
                showToast('请制定下周计划')
                return false;
            }
            if (!hinderAndMeasures) {
                showToast('请填写可能的阻碍与相应措施')
                return false;
            }

            if (!checkDate) {
                showToast('请选择周间检查时间')
                return false;
            }
            if (!nextSessionDate) {
                showToast('请选择下次教练面谈时间')
                return false;
            }
        }

        return true;
    }

    const handleSave = () => {
        if (!checkParams()) {
            return;
        }
        showLoading('提交中')
        const goalsStr = goals.filter(g => !!g).join(',')
        saveCoachingSessions(params.id, level, reviews, material, goalsStr, nextWeeklyObjectives, lastWeeklyObjectives, checkDate ? checkDate.getTime() : undefined, nextSessionDate ? nextSessionDate.getTime() : undefined, hinderAndMeasures).then(res => {
            hideLoading()
            showToast('提交成功')
        }).catch(err => {
            hideLoading()
            showToast('提交失败')
        })
    }


    // const lastWeeklyObjectivesChange = (index: number, key: 'hinder_factors' | 'success_factors') => (event: React.ChangeEvent<HTMLInputElement>) => {
    //     lastWeeklyObjectives[index][key] = event.target.value
    //     setLastWeeklyObjectives([...lastWeeklyObjectives])
    // }

    const onRatingChange = (index: number, key: 'complete_level' | 'complate_quality' | 'diffcultly_level') => (event: React.ChangeEvent<{}>, value: number | null) => {
        lastWeeklyObjectives[index][key] = value;
        setLastWeeklyObjectives([...lastWeeklyObjectives])
    }

    const lastObjectiveStateView = (index: number) => {
        const obj = lastWeeklyObjectives[index]
        const completed = (obj.complete_level && obj.complate_quality)
        return <Box className={clsx({ [classes.unfinished]: !completed, [classes.finished]: completed })}>
            {
                completed ?
                    <Typography color="inherit" variant="caption"><CheckCircleIcon style={{ verticalAlign: 'middle', marginTop: '-1px' }} color="inherit" fontSize="small" />已评估</Typography> :
                    <Typography color="inherit" variant="caption"><ErrorIcon style={{ verticalAlign: 'middle', marginTop: '-1px' }} color="inherit" fontSize="small" />待评估</Typography>
            }
        </Box>
    }

  

    return <div>
        <ClientProfilesView profiles={profiles} />
        <Paper style={{ padding: '24px', boxSizing: 'border-box', display: 'flex', marginTop: '20px' }}>
            <Grid container spacing={3}>
                <Grid item xs={9}>
                    <div className={classes.titleBox} style={{ marginBottom: '20px' }}>
                        <Typography>{level <= numberOfTimes ? `第${level}次教练` : `教练总结`}</Typography>
                        <Button onClick={handleSave}>提交</Button>
                    </div>
                    <Box>
                        <Typography align="center">教练目标</Typography>
                        {goals.map((goal, index) =>
                            <TextField onChange={onGoalsChange(index)} key={index} value={goal} label={`目标${index + 1}`} style={{ margin: '8px 0' }} fullWidth />
                        )}
                    </Box>

                    {level !== 1 &&
                        <Box mt={5}>
                            <Typography >评估上周计划执行情况</Typography>
                            <Box mt={2} border="1px solid rgba(0,0,0,.1)">
                                <Tabs variant="fullWidth" value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)}>
                                    {lastWeeklyObjectives.map((obj, index) => <PlanTab key={obj.index} label={
                                        <Box style={{ width: '100%' }}>
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Typography variant="subtitle2">计划{obj.index}</Typography>
                                                {lastObjectiveStateView(index)}
                                            </Box>
                                            <Typography variant="body2">{obj.objectives}</Typography>
                                        </Box>
                                    } value={obj.index - 1} />)}
                                </Tabs>
                                <Divider />
                                {lastWeeklyObjectives.map((obj, index) =>
                                    <Box key={index} hidden={obj.index - 1 !== tabIndex} p={3}>
                                        <Typography variant="body2">完成程度和完成质量各5分，总计10分</Typography>
                                        <Grid container>
                                            <Grid item xs={4} >
                                                <Box display="flex" flexDirection="column" alignItems="flex-start">
                                                    <Box mt={2} mb={2} display="flex" alignItems="center"><Typography display="inline">完成程度:</Typography><Rating onChange={onRatingChange(index, 'complete_level')} value={obj.complete_level} style={{ marginLeft: '10px' }} /></Box>
                                                    <Box mt={2} mb={2} display="flex" alignItems="center"><Typography display="inline">完成质量:</Typography><Rating onChange={onRatingChange(index, 'complate_quality')} value={obj.complate_quality} style={{ marginLeft: '10px' }} /></Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )}
                            </Box>
                            <Box mt={2}>
                                <TextField value={reviews} onChange={(event) => setReviews(event.target.value)} variant="outlined" fullWidth label="教练评价" multiline rows={5} />

                            </Box>
                        </Box>
                    }

                    {
                        level <= numberOfTimes && <Box mt={3}>
                            <Typography>制定下周计划</Typography>
                            <Box mt={2} >
                                <Grid container spacing={2}>
                                    {nextWeeklyObjectives.map((objectives, index) =>
                                        <Grid item xs={4} key={objectives.index}>
                                            <TextField onChange={onNextWeeklyObjectsChange(index)} value={objectives.objectives} fullWidth variant="outlined" rows={5} multiline label={`计划${objectives.index}`} />
                                        </Grid>
                                    )}
                                </Grid>
                            </Box>

                            <Box mt={3}>
                                <TextField value={hinderAndMeasures} onChange={(event) => setHinderAndMeasures(event.target.value)} variant="outlined" fullWidth label="可能的阻碍与相应措施" multiline rows={5} />
                            </Box>

                            <Box mt={3} display="flex" justifyContent="space-between" alignItems="flex-end" >
                                <Box>
                                    <Box mt={2}>
                                        <KeyboardDateTimePicker
                                            label="周间检查时间"
                                            value={checkDate}
                                            format="yyyy-MM-dd HH:mm"
                                            onChange={(date: Date | null) => setCheckDate(date)}
                                        />
                                    </Box>
                                    <Box mt={2}>
                                        <KeyboardDateTimePicker
                                            label="下次教练面谈时间"
                                            value={nextSessionDate}
                                            format="yyyy-MM-dd HH:mm"
                                            onChange={(date: Date | null) => setNextSessionDate(date)}
                                        />
                                    </Box>
                                    <Box mt={2}>
                                        <TextField value={material} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setMaterial(event.target.value)} fullWidth label="下次教练资料和课件" />
                                    </Box>
                                </Box>
                                <div>
                                    <Button onClick={handleSave}>提交</Button>
                                </div>
                            </Box>
                        </Box>
                    }
                </Grid>
                <Grid item xs={3} >
                    <Grid container style={{ height: '100%' }}>
                        <Grid item xs={1}>
                            <Divider orientation="vertical" />
                        </Grid>
                        <Grid item xs={11}>
                            <Box display="flex" flexDirection="column" height="100%">
                                <Box mb={2} display="flex" alignItems="center"> <Typography>教练笔记（自动保存）</Typography>{notesSaveing && <CircularProgress size={16} />}</Box>
                                <Box height="100%"><TextField value={notes} onChange={handleNotesChange} {...textareaProps} variant="outlined" multiline fullWidth /></Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    </div>
}

export default ClientCoaching